import React, {useState,useEffect} from 'react'
import styled from 'styled-components';
import { Link } from 'react-router-dom'
import img from '../../assets/images/php.jpg'
import { BorderBottom, Container, Shapes, TitleSection, WrappCertificates, Wrapps, WrappsCerti } from '../../globalStyle';
import LeftArrow from '../left-arrow/arrow';
import ImageError from '../error/error';
import { url } from '../../App';
import Skeleton from '../skeleton/skeleton';

const Wrapp = styled(Link)`
        text-decoration:none;
        width:90%;
    `
    const Img = styled.img`
        width:100%;
        margin-right:30px;
        /* box-shadow: 30px 30px 0  #F9A826; */
        border:2px solid #F9A826;
        margin-top:80px;
        &:hover{
            transform: scale(1.02);
            transition:.5s;
        }
        @media screen and (max-width: 600px){
            margin-bottom:80px;
            margin-top:0;
        }
        @media screen and (max-width: 1100px){
            margin-right:80px;
            margin-bottom:80px;
            margin-top:0;
        }

    `
        
        
function CertificatesAll(){
    const [data, setData ] = useState([]);
    const [loading, setLoading ] = useState(false);
    const [error, setError] = useState(false);

    useEffect(() => {
    const getAllCertificates = async() => {
        setLoading(true)
        try{
            let response = await fetch(`${url}/certificate`);
            let data = await response.json();
            setData(data.data);
        } catch(error){
            setError(true)
        } finally{
            setLoading(false)
        }
    }
       getAllCertificates();
       return()=>{
           setData([])
       }
    },[])

    if(error){
        return(
            <ImageError />
        )
    }
   
    
    return(
        <>  
        <WrappCertificates margin>
        <TitleSection>All-Certificates</TitleSection>
        <BorderBottom />
        <WrappsCerti>
            { 
                loading ? (<Skeleton width={"300px"} height={"320px"} amount={6} />) : (
                    data && data.map(item => {
                        return(
                            <Wrapp to={'/certificates/' + item.id} key={item.id}>
                                    <Img src={item.image} alt="certificates" />
                            </Wrapp>
                        )
                    })
                )
            }
        </WrappsCerti>
        </WrappCertificates>
        </>
    )
}
export default CertificatesAll;